import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../pages/Personal Attendance/useAuth";
import { TOOLTRACKER_URL } from "../helpers/externalApps";

const Navdata = () => {
  const history = useNavigate();
  // Round 1 (DI parity): pull canAccessModule so the Digital Inspection
  // sidebar entry obeys the same server-resolved "app.di" module gate as
  // the /di route (RoleProtected) and the MenuHub card. No other sidebar
  // entry was touched.
  const { isItAdmin, isHR, isManager, isSuperUser, isMPC, canAccessModule, hasAccess, isIndiaAccount } = useAuth();

  // Tool Tracker's URL lives in helpers/externalApps.js (shared with the
  // Workflows ▸ Apps card).

  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);
  // Batch FE-P10: collapsible state for the Human Resource sidebar group.
  const [isHumanResource, setIsHumanResource] = useState(false);
  const [isTimeandAttendance, setIsTimeandAttendance] = useState(false);

  // Apps
  const [isEmail, setEmail] = useState(false);
  const [isSubEmail, setSubEmail] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isProjects, setIsProjects] = useState(false);
  const [isTasks, setIsTasks] = useState(false);
  const [isCRM, setIsCRM] = useState(false);
  // Round 11: each menu group needs its own open/close state so they
  // don't toggle together. The two below were sharing isCRM, which made
  // clicking either one expand/collapse both.
  const [isPersonalAttendance, setIsPersonalAttendance] = useState(false);
  const [isTravelExpense,      setIsTravelExpense]      = useState(false);
  const [isCrypto, setIsCrypto] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isSupportTickets, setIsSupportTickets] = useState(false);
  const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);
  const [isJobs, setIsJobs] = useState(false);
  const [isJobList, setIsJobList] = useState(false);
  const [isCandidateList, setIsCandidateList] = useState(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  const [isLockScreen, setIsLockScreen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isVerification, setIsVerification] = useState(false);
  const [isError, setIsError] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);

  // Charts
  const [isApex, setIsApex] = useState(false);

  // Multi Level
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsTimeandAttendance(false);
    }
    if (iscurrentState === "Widgets") {
      history("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
    isTimeandAttendance,
  ]);

  // ── Apps (sidebar "Apps" dropdown) ─────────────────────────────────────────
  // Same list and gates as the Workflows ▸ Apps card (MenuHub). IT Admin
  // bypasses every gate, mirroring RoleProtected.
  //   • Digital Inspection — Round 1 (DI parity): gated by the server-resolved
  //     "app.di" module, same as the /di route and the MenuHub card.
  //   • Perflexion — owner request 2026-07: engineering part-formula tool.
  //   • Expected Visitors — Round 38: restored (the /visitors route was always alive).
  //   • Support (Freshdesk) — "support" module (open to every employee;
  //     agent/admin scope is enforced server-side in FreshdeskController).
  //   • Tool Tracker — separate Flask app opened in a NEW tab (isExternal).
  //     Gated by "app.tooltracker" = "Tool Tracker - Open" permission (Access
  //     Management ▸ Role Permissions / Direct User Permissions) or IT Admin.
  const appsSubItems = [
    (isItAdmin || canAccessModule("app.di")) && {
      id: "di", tone: "green", label: "Digital Inspection", icon: "ri-checkbox-circle-fill", link: "/di", parentId: "apps",
    },
    (isItAdmin || canAccessModule("app.perflexion")) && {
      id: "perflexion", tone: "violet", label: "Perflexion", icon: "ri-compasses-2-fill", link: "/perflexion", parentId: "apps",
    },
    (isItAdmin || canAccessModule("app.mafia")) && {
      id: "mafia", tone: "slate", label: "Mafia Aux", icon: "ri-key-2-fill", link: "/mafia", parentId: "apps",
    },
    (isItAdmin || canAccessModule("app.displayboard")) && {
      id: "displayboards", tone: "cyan", label: "Display Board", icon: "ri-clipboard-fill", link: "/display-boards", parentId: "apps",
    },
    (isItAdmin || canAccessModule("app.visitors")) && {
      id: "expectedvisitors", tone: "orange", label: "Expected Visitors", icon: "ri-user-received-2-fill", link: "/visitors", parentId: "apps",
    },
    (isItAdmin || canAccessModule("support")) && {
      id: "support", tone: "indigo", label: "Support", icon: "ri-customer-service-2-fill", link: "/support", parentId: "apps",
    },
    // Owner 2026-10-08: the Organizational Chart is an App, open to every signed-in account.
    (isItAdmin || canAccessModule("orgchart.open")) && {
      id: "orgchart", tone: "blue", label: "Organizational Chart", icon: "ri-organization-chart", link: "/organizational-chart", parentId: "apps",
    },
    (isItAdmin || canAccessModule("app.tooltracker")) && {
      id: "tooltracker", tone: "teal", label: "Tool Tracker", icon: "ri-hammer-fill", link: TOOLTRACKER_URL, isExternal: true, parentId: "apps",
    },
  ].filter(Boolean);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    // Owner 2026-10-08: only for accounts that have the time pages (an India account has
    // MAFIA Aux, DI and DMS only, so it does not see this entry).
    (isItAdmin || canAccessModule("time.open") || canAccessModule("attendance.mine")) && {
      id: "dashboard",
      tone: "violet",
      // Owner (2026-10-06): "General SS White" becomes the time page: clock in and out,
      // FTO and COA. The other modules are reached from the department pages, the home
      // page shortcuts, the Apps list and the search.
      label: "Time, FTO & COA",
      icon: "ri-time-line",
      link: "/workflows",
      stateVariables: isDashboard,
      // Round 16: clicking the entry opens the /workflows launcher (cards +
      // sub-cards drill-down). The home page (/dashboard) stays accessible
      // via the logo / breadcrumb.
      click: function (e) {
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    // Owner 2026-10-08: Document Management in the menu for INDIA accounts only (they have no
    // department pages; Florida people reach DMS from their department page, the home page and
    // the search). Same drill-down as the hub card (All Documents, My Drafts, My Pending
    // Approvals, Ready for Release).
    isIndiaAccount && (canAccessModule("dms.all") || canAccessModule("dms.create") || canAccessModule("dms.myDrafts")
      || canAccessModule("dms.myApprovals") || canAccessModule("dms.release")) && {
      id: "documents",
      tone: "slate",
      label: "Document Management",
      icon: "ri-folder-2-line",
      link: "/workflows?wf=dms",
    },
    // {
    //     id: "apps",
    //     label: "Apps",
    //     icon: "bx bx-layer",
    //     link: "/#",
    //     click: function (e) {
    //         e.preventDefault();
    //         setIsApps(!isApps);
    //         setIscurrentState("Apps");
    //         updateIconSidebar(e);
    //     },
    //     stateVariables: isApps,
    //     subItems: [
    //         {
    //             id: "calendar",
    //             label: "Calendar",
    //             link: "/apps-calendar",
    //             parentId: "apps",
    //         },
    //         {
    //             id: "chat",
    //             label: "Chat",
    //             link: "/apps-chat",
    //             parentId: "apps",
    //         },
    //         {
    //             id: "mailbox",
    //             label: "Email",
    //             link: "/#",
    //             parentId: "apps",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setEmail(!isEmail);
    //             },
    //             stateVariables: isEmail,
    //             childItems: [
    //                 {
    //                     id: 1,
    //                     label: "Mailbox",
    //                     link: "/apps-mailbox",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 2,
    //                     label: "Email Templates",
    //                     link: "/#",
    //                     parentId: "apps",
    //                     isChildItem: true,
    //                     stateVariables: isSubEmail,
    //                     click: function (e) {
    //                         e.preventDefault();
    //                         setSubEmail(!isSubEmail);
    //                     },
    //                     childItems: [
    //                         {
    //                             id: 2,
    //                             label: "Basic Action",
    //                             link: "/apps-email-basic",
    //                             parentId: "apps",
    //                         },
    //                         {
    //                             id: 3,
    //                             label: "Ecommerce Action",
    //                             link: "/apps-email-ecommerce",
    //                             parentId: "apps",
    //                         },
    //                     ],
    //                 },
    //             ],
    //         },
    //         {
    //             id: "appsecommerce",
    //             label: "Ecommerce",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsEcommerce(!isEcommerce);
    //             },
    //             parentId: "apps",
    //             stateVariables: isEcommerce,
    //             childItems: [
    //                 {
    //                     id: 1,
    //                     label: "Products",
    //                     link: "/apps-ecommerce-products",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 2,
    //                     label: "Product Details",
    //                     link: "/apps-ecommerce-product-details",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 3,
    //                     label: "Create Product",
    //                     link: "/apps-ecommerce-add-product",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 4,
    //                     label: "Orders",
    //                     link: "/apps-ecommerce-orders",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 5,
    //                     label: "Order Details",
    //                     link: "/apps-ecommerce-order-details",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 6,
    //                     label: "Customers",
    //                     link: "/apps-ecommerce-customers",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 7,
    //                     label: "Shopping Cart",
    //                     link: "/apps-ecommerce-cart",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 8,
    //                     label: "Checkout",
    //                     link: "/apps-ecommerce-checkout",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 9,
    //                     label: "Sellers",
    //                     link: "/apps-ecommerce-sellers",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 10,
    //                     label: "Seller Details",
    //                     link: "/apps-ecommerce-seller-details",
    //                     parentId: "apps",
    //                 },
    //             ],
    //         },
    //         {
    //             id: "appsprojects",
    //             label: "Projects",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsProjects(!isProjects);
    //             },
    //             parentId: "apps",
    //             stateVariables: isProjects,
    //             childItems: [
    //                 {
    //                     id: 1,
    //                     label: "List",
    //                     link: "/apps-projects-list",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 2,
    //                     label: "Overview",
    //                     link: "/apps-projects-overview",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 3,
    //                     label: "Create Project",
    //                     link: "/apps-projects-create",
    //                     parentId: "apps",
    //                 },
    //             ],
    //         },
    //         {
    //             id: "tasks",
    //             label: "Tasks",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsTasks(!isTasks);
    //             },
    //             parentId: "apps",
    //             stateVariables: isTasks,
    //             childItems: [
    //                 {
    //                     id: 1,
    //                     label: "List View",
    //                     link: "/apps-tasks-list-view",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 2,
    //                     label: "Task Details",
    //                     link: "/apps-tasks-details",
    //                     parentId: "apps",
    //                 },
    //             ],
    //         },
    //         {
    //             id: "appscrm",
    //             label: "CRM",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsCRM(!isCRM);
    //             },
    //             parentId: "apps",
    //             stateVariables: isCRM,
    //             childItems: [
    //                 { id: 1, label: "Contacts", link: "/apps-crm-contacts" },
    //                 { id: 2, label: "Companies", link: "/apps-crm-companies" },
    //                 { id: 3, label: "Deals", link: "/apps-crm-deals" },
    //                 { id: 4, label: "Leads", link: "/apps-crm-leads" },
    //             ],
    //         },
    //         {
    //             id: "appscrypto",
    //             label: "Crypto",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsCrypto(!isCrypto);
    //             },
    //             parentId: "apps",
    //             stateVariables: isCrypto,
    //             childItems: [
    //                 { id: 1, label: "Transactions", link: "/apps-crypto-transactions" },
    //                 { id: 2, label: "Buy & Sell", link: "/apps-crypto-buy-sell" },
    //                 { id: 3, label: "Orders", link: "/apps-crypto-orders" },
    //                 { id: 4, label: "My Wallet", link: "/apps-crypto-wallet" },
    //                 { id: 5, label: "ICO List", link: "/apps-crypto-ico" },
    //                 { id: 6, label: "KYC Application", link: "/apps-crypto-kyc" },
    //             ],
    //         },
    //         {
    //             id: "invoices",
    //             label: "Invoices",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsInvoices(!isInvoices);
    //             },
    //             parentId: "apps",
    //             stateVariables: isInvoices,
    //             childItems: [
    //                 { id: 1, label: "List View", link: "/apps-invoices-list" },
    //                 { id: 2, label: "Details", link: "/apps-invoices-details" },
    //                 { id: 3, label: "Create Invoice", link: "/apps-invoices-create" },
    //             ],
    //         },
    //         {
    //             id: "supportTickets",
    //             label: "Support Tickets",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsSupportTickets(!isSupportTickets);
    //             },
    //             parentId: "apps",
    //             stateVariables: isSupportTickets,
    //             childItems: [
    //                 { id: 1, label: "List View", link: "/apps-tickets-list" },
    //                 { id: 2, label: "Ticket Details", link: "/apps-tickets-details" },
    //             ],
    //         },
    //         {
    //             id: "NFTMarketplace",
    //             label: "NFT Marketplace",
    //             link: "/#",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsNFTMarketplace(!isNFTMarketplace);
    //             },
    //             parentId: "apps",
    //             stateVariables: isNFTMarketplace,
    //             childItems: [
    //                 { id: 1, label: "Marketplace", link: "/apps-nft-marketplace" },
    //                 { id: 2, label: "Explore Now", link: "/apps-nft-explore" },
    //                 { id: 3, label: "Live Auction", link: "/apps-nft-auction" },
    //                 { id: 4, label: "Item Details", link: "/apps-nft-item-details" },
    //                 { id: 5, label: "Collections", link: "/apps-nft-collections" },
    //                 { id: 6, label: "Creators", link: "/apps-nft-creators" },
    //                 { id: 7, label: "Ranking", link: "/apps-nft-ranking" },
    //                 { id: 8, label: "Wallet Connect", link: "/apps-nft-wallet" },
    //                 { id: 9, label: "Create NFT", link: "/apps-nft-create" },
    //             ],
    //         },
    //         {
    //             id: "filemanager",
    //             label: "File Manager",
    //             link: "/apps-file-manager",
    //             parentId: "apps",
    //         },
    //         {
    //             id: "todo",
    //             label: "To Do",
    //             link: "/apps-todo",
    //             parentId: "apps",
    //         },
    //         {
    //             id: "job",
    //             label: "Jobs",
    //             link: "/#",
    //             parentId: "apps",
    //             badgeName: "New",
    //             badgeColor: "success",
    //             isChildItem: true,
    //             click: function (e) {
    //                 e.preventDefault();
    //                 setIsJobs(!isJobs);
    //             },
    //             stateVariables: isJobs,
    //             childItems: [
    //                 {
    //                     id: 1,
    //                     label: "Statistics",
    //                     link: "/apps-job-statistics",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 2,
    //                     label: "Job Lists",
    //                     link: "/#",
    //                     parentId: "apps",
    //                     isChildItem: true,
    //                     stateVariables: isJobList,
    //                     click: function (e) {
    //                         e.preventDefault();
    //                         setIsJobList(!isJobList);
    //                     },
    //                     childItems: [
    //                         {
    //                             id: 1,
    //                             label: "List",
    //                             link: "/apps-job-lists",
    //                             parentId: "apps",
    //                         },
    //                         {
    //                             id: 2,
    //                             label: "Grid",
    //                             link: "/apps-job-grid-lists",
    //                             parentId: "apps",
    //                         },
    //                         {
    //                             id: 3,
    //                             label: "Overview",
    //                             link: "/apps-job-details",
    //                             parentId: "apps",
    //                         },
    //                     ],
    //                 },
    //                 {
    //                     id: 3,
    //                     label: "Candidate Lists",
    //                     link: "/#",
    //                     parentId: "apps",
    //                     isChildItem: true,
    //                     stateVariables: isCandidateList,
    //                     click: function (e) {
    //                         e.preventDefault();
    //                         setIsCandidateList(!isCandidateList);
    //                     },
    //                     childItems: [
    //                         {
    //                             id: 1,
    //                             label: "List View",
    //                             link: "/apps-job-candidate-lists",
    //                             parentId: "apps",
    //                         },
    //                         {
    //                             id: 2,
    //                             label: "Grid View",
    //                             link: "/who-in-the-building",
    //                             parentId: "apps",
    //                         },
    //                     ],
    //                 },
    //                 {
    //                     id: 4,
    //                     label: "Application",
    //                     link: "/apps-job-application",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 5,
    //                     label: "New Job",
    //                     link: "/apps-job-new",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 6,
    //                     label: "Companies List",
    //                     link: "/apps-job-companies-lists",
    //                     parentId: "apps",
    //                 },
    //                 {
    //                     id: 7,
    //                     label: "Job Categories",
    //                     link: "/apps-job-categories",
    //                     parentId: "apps",
    //                 },
    //             ],
    //         },
    //         {
    //             id: "apiKey",
    //             label: "API Key",
    //             link: "/apps-api-key",
    //             parentId: "apps",
    //             badgeName: "New",
    //             badgeColor: "success",
    //         },
    //     ],
    // },
    // "departments" section header — only show if the user is going to see any
    // department dashboard below. Otherwise an orphan header appears for Employees.
    // Round 23 (owner green-lit): departments grouped under three labeled
    // sections — Operations / Business / People & Systems. Every item keeps
    // its exact label, link, icon, and permission gate; only the order and
    // the section headers changed. Headers are gated to the union of their
    // group so no orphan header ever shows.
    (canAccessModule("dept.engineering") || canAccessModule("dept.planning") || canAccessModule("dept.production") || canAccessModule("dept.quality") || canAccessModule("dept.shipping")) && {
      label: "operations",
      isHeader: true,
    },    canAccessModule("dept.engineering") && {
      id: "authentication",
      label: "Engineering",
      tone: "teal",
      icon: "ri-tools-line",
      link: "/engineering",
    },    canAccessModule("dept.planning") && {
      id: "authentication",
      label: "Planning",
      tone: "violet",
      icon: "ri-calendar-todo-line",
      link: "/planning",
    },    canAccessModule("dept.production") && {
      id: "authentication",
      label: "Production",
      tone: "orange",
      icon: "ri-building-3-line",
      link: "/production",
    },    canAccessModule("dept.quality") && {
      id: "authentication",
      label: "Quality",
      tone: "green",
      icon: "ri-shield-check-line",
      link: "/quality",
    },    canAccessModule("dept.shipping") && {
      id: "authentication",
      label: "Shipping",
      tone: "blue",
      icon: "ri-truck-line",
      link: "/shipping",
    },
    (canAccessModule("dept.accounting") || canAccessModule("dept.sales") || canAccessModule("dept.shukla")) && {
      label: "business",
      isHeader: true,
    },    canAccessModule("dept.accounting") && {
      id: "authentication",
      label: "Accounting",
      tone: "indigo",
      icon: "ri-calculator-line",
      link: "/accounting",
    },    canAccessModule("dept.sales") && {
      id: "authentication",
      label: "Sales",
      tone: "cyan",
      icon: "ri-line-chart-line",
      link: "/sales",
    },    canAccessModule("dept.shukla") && {
      id: "authentication",
      label: "Shukla",
      tone: "slate",
      icon: "ri-bank-line",
      link: "/shukla",
    },
    {
      label: "people & systems",
      isHeader: true,
    },    (isHR || isItAdmin) && {
      id: "humanresource",
      tone: "pink",
      label: "Human Resource",
      icon: "ri-team-line",
      link: "/humanresource",
      stateVariables: isHumanResource,
      click: function () {
        // Do NOT preventDefault — we want the router to navigate
        // to /humanresource. We just also flip the expand state so
        // the nested HR Dashboard becomes visible.
        setIsHumanResource(!isHumanResource);
      },
      childItems: [
        {
          // Round: HR UI Simplification (Phase 1) — label only. The route
          // and page are untouched; "Overview (analytics)" makes clear this
          // is the analytics view UNDER Human Resource, not a second HR
          // home (acceptance criterion 5). Same link, same gating.
          id: "hr-dashboard",
          label: "Overview (analytics)",
          tone: "pink",
          link: "/hr/dashboard",
          parentId: "humanresource",
        },
      ],
    },    {
      id: "myprofile",
      tone: "blue",
      label: "My Profile",
      icon: "ri-user-settings-line",
      link: "/profile/me",
    },    canAccessModule("dept.it") && {
      id: "authentication",
      label: "Information Technology",
      tone: "indigo",
      icon: "ri-computer-line",
      link: "/it",
    },    canAccessModule("dept.supervisor") && {
      id: "authentication",
      label: "Supervisor",
      tone: "teal",
      icon: "ri-user-star-line",
      link: "/supervisor",
    },    (isItAdmin ||
           hasAccess("KPI - View Hub") ||
           hasAccess("KPI - Finance Reports") || hasAccess("KPI - Sales Reports") ||
           hasAccess("KPI - Inventory Reports") || hasAccess("KPI - Orders Reports") ||
           hasAccess("KPI - Quality Reports") || hasAccess("KPI - Vendor Reports") ||
           hasAccess("KPI - Planning Reports") ||
           hasAccess("KPI - X-Ray Report") || hasAccess("KPI - Aged Receivables") ||
           hasAccess("KPI - Aged Payables") || hasAccess("KPI - Variance Report")) && {
      id: "authentication",
      label: "KPIs",
      tone: "orange",
      icon: "ri-bar-chart-2-line",
      link: "/kpi",
    },
    // ── Departments — gated by role ───────────────────────────────────────────
    // Gates follow legacy defaults: department dashboards are managerial views.
    // IT Admin always passes any gate (handled inside the && via isItAdmin).
    // Unsure/edit these in one line; they're independent of business logic.


    // Batch FE-P10 (fix): Human Resource stays a direct link to
    // /humanresource (so clicking the parent still navigates, no
    // forced expand-first). HR Dashboard is nested as the only
    // child, so it shows as an indented item underneath. The
    // group still toggles via stateVariables so users can show/
    // hide the nested entry if they want a cleaner sidebar.

    // Phase 3 / Feature 3: My Profile self-service — available to every
    // authenticated user. AuthProtected at Layout level enforces sign-in.








    // Phase 3 hotfix: Supervisor and KPIs sidebar entries were gated to
    // super-user / IT only, which hid them from RoleId=5 managers. The
    // Supervisor landing page is a launchpad for the approval workflows
    // managers already use; KPIs surface team metrics relevant to any
    // manager. Both should be visible to anyone with isManager=true.


    // Apps — one collapsible "Apps" entry (owner request): clicking it opens the
    // list of apps (appsSubItems above) instead of showing every app in the
    // sidebar at once. Hidden entirely if the user can see none of them.
    appsSubItems.length > 0 && {
      id: "apps",
      tone: "violet",
      label: "Apps",
      icon: "ri-apps-2-line",
      link: "/#",
      stateVariables: isApps,
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps);
        setIscurrentState("Apps");
        updateIconSidebar(e);
      },
      subItems: appsSubItems,
    },
  ].filter(Boolean); // strip out items that evaluated to `false` from role gates above

  // ── IT Admin section — only visible to IT Admin users ─────────────────────
  // Backend endpoints under /api/admin are also protected with
  // [Authorize(Roles = "IT Admin")] so hiding the menu is not the security
  // boundary; this just keeps the UI honest.
  // ── IT Admin section — visible to IT Admin OR anyone granted an admin tool ──
  // Backend endpoints under /api/admin are also protected with per-page policies
  // (CanManageAccess / CanManageEmployeeRoles / …) so hiding the menu is not the
  // security boundary; this just keeps the UI honest. admin.hub is true if the
  // user has any admin-page permission (or is IT Admin).
  if (isItAdmin || canAccessModule("admin.hub")) {
    menuItems.push(
      {
        label: "IT Admin",
        isHeader: true,
      },
      // Round 20: consolidated into a single landing page (/admin) that
      // shows Employee Roles, EPO Limits, and User Permissions as cards.
      // Replaces the two separate links that used to live here.
      {
        id: "adminHub",
        label: "Admin",
        tone: "indigo",
        icon: "ri-shield-keyhole-line",
        link: "/admin",
      }
    );
  }

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
